import { useEffect, useState } from 'react'
import styles from './EstablishmentCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import iconEdit from '../../assets/icons/iconEdit.svg'
import PlatformCardShortInformation from '../../components/PlatformCardShortInformation/PlatformCardShortInformation'

import { useLocation, useNavigate, useParams } from 'react-router-dom'
import PATH from '../../navigation/path'

import { useAppDispatch, useAppSelector } from '../../redux/types/types'

import Loader from '../../components/UI/Loader/Loader'
import noImage from '../../assets/img/no-image.jpg'

import { getCurrentEstablishment } from '../../redux/actions/establishmentsAction'
import EventsList from '../../components/EventsList/EventsList'
import { placesPerPage } from '../../constants/constants'
import { PlaceEstablishment } from '../../redux/actions/types'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import NewSlider from '../NewSlider/NewSlider'
import CustomButton from '../../components/UI/CustomButton/CustomButton'

const EstablishmentCardPage = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [edit, setEdit] = useState(false)

  const navigate = useNavigate()
  const [navItem, setNavItem] = useState(1)

  let { user } = useAppSelector((state) => state.auth)
  let { isLoading, currentEstablishment } = useAppSelector((state) => state.establishments)

  const { token } = useAppSelector((state) => state.auth)

  const { establishmentId } = useParams<{ establishmentId: string }>()

  const dispatch = useAppDispatch()
  const location = useLocation()

  const dummyData = (imagesArr: string[]) => {
    return imagesArr.map((image, index) => {
      return { id: index, src: `${process.env.REACT_APP_BASE_URL_IMAGES}${image}` }
    })
  }

  const imagesFull = dummyData(currentEstablishment.images)

  const onRedirectToEditCardPage = () => {
    navigate(`${PATH.editEstablishmentCardPage}${establishmentId}`)
  }

  useEffect(() => {
    dispatch(getCurrentEstablishment({ establishmentId: establishmentId, token }))
  }, [establishmentId, dispatch])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.platformCard}>
      <Navbar />
      <div className={styles.container}>
        <HeaderForCard
          img={
            currentEstablishment.logo ? (
              <img
                className={styles.imgLogo}
                src={`${process.env.REACT_APP_BASE_URL_IMAGES}${currentEstablishment.logo}`}
              />
            ) : (
              <></>
            )
          }
          title={currentEstablishment.name}
        />

        <div className={styles.navContainer}>
          <div
            onClick={() => setNavItem(1)}
            className={navItem === 1 ? `${styles.active} ${styles.navItem}` : styles.navItem}
          >
            Основная информация
          </div>
          <div
            onClick={() => setNavItem(2)}
            className={navItem === 2 ? `${styles.active} ${styles.navItem}` : styles.navItem}
          >
            Залы площадки
          </div>
        </div>
        <div style={navItem === 2 ? { maxWidth: '100%' } : {}} className={styles.content}>
          {navItem === 1 && (
            <>
              <div className={styles.editContainer}>
                <span>Основная информация</span>
                <CustomButton
                  iconSrc={iconEdit}
                  className={styles.editBtn}
                  title={''}
                  onClick={onRedirectToEditCardPage}
                />
              </div>
              {!edit && (
                <>
                  {imagesFull.length !== 0 ? (
                    <div className={styles.slider}>
                      <NewSlider slides={imagesFull} />
                    </div>
                  ) : (
                    <div className={styles.slider}>
                      <img className={styles.noImage} src={noImage} alt='noImage' />
                    </div>
                  )}
                  <div className={styles.leftBlock}>
                    <PlatformCardShortInformation platformData={currentEstablishment} />
                  </div>
                </>
              )}
            </>
          )}
          {navItem === 2 && (
            <>
              <div className={styles.placesContainer}>
                {Array.isArray(currentEstablishment.places) &&
                currentEstablishment.places.length > 0 ? (
                  <EventsList
                    eventList={currentEstablishment.places.map((place: PlaceEstablishment) => ({
                      id: place.id,
                      title: place.name,
                      subTitle: place.city,
                      numberOfPerson: place.size.toString(),
                      images: Array.isArray(place.images)
                        ? place.images.map((img: string, index: number) => ({
                            id: index,
                            src: img,
                          }))
                        : [],
                    }))}
                    pageSize={placesPerPage}
                    bookingData={location?.state ? location.state : null}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalCountPages={currentEstablishment.places.length}
                  />
                ) : (
                  <div className={styles.center}>Список залов пуст...</div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default EstablishmentCardPage
